import React from "react";

import {
  Swiper,
  SwiperSlide,
} from "swiper/react";

import {
  Autoplay,
  Navigation,
  Pagination,
  Keyboard,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../css/DemoCss.css";

const mediaItems = [
  {
    id: 1,
    type: "image",
    src: "/demoImages/image2.jpeg",
    accent: "yellow",
    name: "Obstacle-Avoiding Car",
  },
  {
    id: 2,
    type: "image",
    src: "/demoImages/image3.jpeg",
    accent: "blue",
    name: "Rain Detector Device",
  },
  {
    id: 3,
    type: "image",
    src: "/demoImages/image4.jpeg",
    accent: "purple",
    name: "Smart Street Light",
  },
  {
    id: 4,
    type: "image",
    src: "/demoImages/4.jpg",
    accent: "teal",
    name: "Smart Eyeglasses",
  },
  {
    id: 5,
    type: "image",
    src: "/demoImages/image5.jpeg",
    accent: "yellow",
    name: "RFID Attendance Monitoring System",
  },
  {
    id: 6,
    type: "image",
    src: "/demoImages/image6.jpeg",
    accent: "blue",
    name: "Traffic Light",
  },
];

export default function DemoComponent() {
  return (
    <section className="ms-project-section">
      {/* =========================================
          BACKGROUND
      ========================================= */}

      <div className="ms-project-grid" />

      <div className="ms-project-glow ms-project-glow-blue" />
      <div className="ms-project-glow ms-project-glow-yellow" />

      <div className="container ms-project-container">
        <div className="ms-project-layout">
          {/* =========================================
              LEFT CONTENT
          ========================================= */}

          <div className="ms-project-intro">
            <div className="ms-project-kicker">
              <span />

              PROJECT BASED LEARNING
            </div>

            <h2>
              Real-Time
              <span> Projects.</span>
            </h2>

            <p>
              Students learn by building, testing and
              exploring ideas through practical technology
              projects.
            </p>

            <div className="ms-project-message">
              <div className="ms-project-message-icon">
                ✦
              </div>

              <div>
                <span>
                  LEARNING THROUGH TECHNOLOGY
                </span>

                <strong>
                  Turning concepts into real experiences.
                </strong>
              </div>
            </div>

            {/* SMALL META */}
            <div className="ms-project-meta">
              <div>
                <strong>
                  {String(mediaItems.length).padStart(
                    2,
                    "0"
                  )}
                </strong>

                <span>
                  Projects
                </span>
              </div>

              <span className="ms-project-meta-line" />

              <div>
                <strong>
                  LIVE
                </strong>

                <span>
                  Learning
                </span>
              </div>
            </div>
          </div>

          {/* =========================================
              PROJECT SLIDER
          ========================================= */}

          <div className="ms-project-slider-area">
            <div className="ms-project-slider-label">
              <span />

              Explore student projects
            </div>

            <Swiper
              modules={[
                Pagination,
                Autoplay,
                Navigation,
                Keyboard,
              ]}
              loop
              grabCursor
              speed={800}
              keyboard={{
                enabled: true,
              }}
              autoplay={{
                delay: 3500,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }}
              navigation
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 12,
                },

                701: {
                  slidesPerView: 1.25,
                  spaceBetween: 18,
                },

                992: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },

                1200: {
                  slidesPerView: 2.15,
                  spaceBetween: 22,
                },
              }}
              className="ms-project-swiper"
            >
              {mediaItems.map((item, index) => (
                <SwiperSlide
                  key={item.id}
                  className="ms-project-slide"
                >
                  <article
                    className={`ms-project-card ${item.accent}`}
                  >
                    {/* PROJECT NUMBER */}
                    <div className="ms-project-number">
                      {String(index + 1).padStart(
                        2,
                        "0"
                      )}
                    </div>

                    {/* MEDIA */}
                    <div className="ms-project-media">
                      {item.type === "image" ? (
                        <img
                          src={item.src}
                          alt={item.name}
                          loading={
                            index < 2
                              ? "eager"
                              : "lazy"
                          }
                        />
                      ) : (
                        <video
                          muted
                          loop
                          autoPlay
                          playsInline
                          preload="metadata"
                        >
                          <source
                            src={item.src}
                            type="video/mp4"
                          />

                          Your browser does not support
                          the video tag.
                        </video>
                      )}

                      <div className="ms-project-media-overlay" />

                      <div className="ms-project-media-tag">
                        <span />

                        REAL PROJECT
                      </div>

                      <div className="ms-project-media-bottom">
                        <span>
                          PROJECT {String(index + 1).padStart(2, "0")}
                        </span>

                        <strong>
                          Learning by creating.
                        </strong>
                      </div>
                    </div>

                    {/* CARD FOOTER */}
                    <div className="ms-project-card-footer">
                      <div>
                        <span>
                          MINDSPARK
                        </span>

                        <strong>
                          {item.name}
                        </strong>
                      </div>

                      <div className="ms-project-arrow">
                        ↗
                      </div>
                    </div>

                    <div className="ms-project-card-accent" />
                  </article>
                </SwiperSlide>
              ))}
            </Swiper>

          </div>
        </div>

        {/* =========================================
            BOTTOM
        ========================================= */}

        <div className="ms-project-bottom">
          <span />

          <p>
            Explore • Build • Test • Create
          </p>

          <span />
        </div>
      </div>
    </section>
  );
}
